<template>
  <form class="pa-message-additional-box">
    <button
      type="submit"
      class="button"
      :class="buttonClass"
      :disabled="isDisabledButton"
      @click.prevent="handleClick"
    >{{buttonText}}</button>
  </form>
</template>

<script>
export default {
  props : {
    isLoading   : {
      default: false,
    },

    isDisabled  : {
      default: false,
    }
  },

  data(){
    return {
      buttonClass       : [],
      isDisabledButton  : false,
      buttonText        : 'ログアウトする',
    };
  },

  watch : {
    isDisabled  : {
      handler(value){
        if(value === true){
          this.isDisabledButton = true;
          this.buttonClass      = ['button-disabled'];
        }else{
          this.isDisabledButton = false;
          this.buttonClass      = [];
        }
      },
      immediate: true
    },

    isLoading   : {
      handler(value){
        if(value === true){
          this.isDisabledButton = true;
          this.buttonClass      = ['is-loading'];
        }else{
          this.isDisabledButton = false;
          this.buttonClass      = [];
        }
      },
      immediate: true
    },
  },

  methods : {
    handleClick(){
      this.$emit('onSubmit');
    }
  }
}
</script>

<style lang="scss">
  @import "@/components/Pages/Office/MessageApp/MessageAppForm.scss";
</style>